import { useNavigate } from "react-router-dom";
import styles from "./CarForm.module.css";
import { useFormik } from "formik";
import initialValues from "./form/initialValues";
import validationSchema from "./form/validationSchema";
import buildCarFormData from "./form/buildCarFormData";
import carService from "../../../services/api/carService";
import SubmitButton from "../../common/SubmitButton";
import { useSelector } from "react-redux";
import { selectCars } from "../../../redux/car/car-slice";
import { PiCarProfileFill } from "react-icons/pi";
import {
  CarHero,
  CarImagePicker,
  CarBasicInfo,
  CarPlateSection,
  CarInitialInfo,
  CarPreview,
} from "./components";
import notify from "../../../services/notify";
import useCarForm from "./hooks/useCarForm";
import { getPlan } from "../../../services/functions";

const CarForm = () => {
  const user = useSelector((state) => state.user.user);
  const cars = useSelector(selectCars);
  // const [loading, setLoading] = useState(false);
  const {

    loading,
    setLoading,

    imageFile,
    setImageFile,

    previewImage,
    setPreviewImage,

} = useCarForm();

  // const [previewImage, setPreviewImage] = useState(null);
  const navigate = useNavigate();

  const closeHandler = () => {
    navigate(-1);
  };

  const plan = getPlan(user);
  // plan => "free"
  // plan => "trial"
  // plan => "pro"

  const submitHandler = async (values) => {

    if (plan === "free" && cars.length >= 1) {
        notify.warning('اشتراک شما پایان یافته است، لطفا اشتراک جدید تهیه نمایید');
        return;
    }
    if (cars.length >= 5) {
      notify.warning('حداکثر 5 خودرو می توانید تعریف کنید');
      return;
    }

    try {
        setLoading(true);
        const userId = user.userId;
        const formData = buildCarFormData(
            values,
            values.imageFile,
            userId
        );

        const result = await carService.createCar(formData);

        formik.resetForm();
        if (previewImage) {
          URL.revokeObjectURL(previewImage); 
        }
        setPreviewImage(null);
        notify.success("خودرو با موفقیت ثبت شد.");

        navigate('/');

    } catch (error) {

      //   toastService.error(
      //     error?.response?.data ||
      //     "خطا در ثبت خودرو"
      // );
      notify.error(error);

    } finally {
        setLoading(false);
    }
};

const formik = useFormik({
  initialValues,
  validationSchema,
  onSubmit: submitHandler,
});

const {
  handleSubmit,
} = formik;


return (

    <form className={styles.container} onSubmit={handleSubmit}>

      <CarHero
        title="خودروی جدید"
        description="خودروی خود را اضافه کنید تا سرویس‌ها و هزینه‌های آن را مدیریت کنیم."
        onBack={closeHandler}
      />

      <CarImagePicker

          formik={formik}

          previewImage={previewImage}

          setPreviewImage={setPreviewImage}

      />

      <CarBasicInfo
          formik={formik}
      />

      <CarPlateSection
          formik={formik}
      />

      <CarInitialInfo
          formik={formik}
      />

      <SubmitButton
        loading={loading}
        icon={<PiCarProfileFill />}
      >
        ثبت خودرو
      </SubmitButton>

    </form>
  );
};

export default CarForm;